var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Duration = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "23", height: "23" }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("circle", { cx: "11.5", cy: "11.5", r: "10.5", fill: color, opacity: ".4" }),
            React.createElement("ellipse", { cx: "11.5", cy: "11.5", fill: "#FFF", rx: "8", ry: "7.5" }),
            React.createElement("path", { fill: "#000111", d: "M11.5 21.5c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm0 1c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z" }),
            React.createElement("path", { fill: "#000111", d: "M11.5 19.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-1a7 7 0 1 1 0-14 7 7 0 0 1 0 14z" }),
            React.createElement("path", { fill: "#001110", d: "M14.909 6.79a.5.5 0 1 1 .757.654l-2.862 3.313A1.5 1.5 0 1 1 11 10.085V8.3a.5.5 0 0 1 .992-.09L12 8.3v1.786l.045.017z" }))));
};
Duration.defaultProps = {
    color: '#00C1B1',
};
export default Duration;
//# sourceMappingURL=Duration.js.map